var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-header-group"},[_c('div',{staticClass:"table-row"},_vm._l((_vm.weekDays),function(day,index){return _c('div',{key:index,staticClass:"table-cell"},[_c('span',[_vm._v(_vm._s(day))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }